import { Component, Input, OnInit } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DropdownRequest,
  FormattedDrug,
  OtherFormularyInformation,
} from '@cigna/pdl-viewer/drug-search/data-access';

@Component({
  selector: 'cigna-print-pdl',
  templateUrl: './print-pdl.component.html',
  styleUrls: ['./print-pdl.component.scss'],
})
export class PrintPdlComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showSearchInfo: boolean;
  @Input() selectedDrugList: FormattedDrug[];
  @Input() alphabet: string;
  @Input() notesCollection: string[];
  @Input() indicator: string;
  @Input() rsdLimitValue: string;
  @Input() msdLimitValue: string;
  @Input() otherInfo: OtherFormularyInformation;
  @Input() consumerId: string;
  @Input() isClassCodeClicked: boolean;
  @Input() selectedItem: DropdownRequest;

  constructor() {}

  ngOnInit(): void {}

  print() {
    // TODO: THIS NEEDS TO BE ENCHANCED FOR THE NEXT RELEASE
    const tab: HTMLElement | null = document.getElementById('tab');
    let style = '<style>';
    style = `${style}.col4 {width: 100px !important;}`;
    style = `${style}table {width: 100%;font: 15px Calibri;}`;
    style = `${style}label {color: #0170bc;}`;
    style = `${style}p { margin: 0 auto; text-align: center;}`;
    style = `${style}.notes-list { list-style-type:none;}`;
    style = `${style}table, th, td {padding: 8px; border: 1px solid #DDD; border-collapse: collapse; text-align: left;}`;
    style = `${style}hr { margin-left: -50px !important;}`;
    style = `${style}.drug-doublerow-table tr td { min-height: 70px; height: 70px; line-height: 1.28;
              padding: 6px 6px 6px 8px;}`;
    style = `${style}.d-table-row { display: table-row !important;} .d-table-cell { display: table-cell !important;}`;
    style = `${style}.row-width {width: 100%;} table.row-width, tr, td.ft-child {border: unset}`;
    style = `${style}.p-0 {padding: 0 !important;} .td-data {border: 1px solid #DDD;}`;
    style = `${style}.drug-doublerow-table tr:first-child td.ft-child {border-top: none;}`;
    style = `${style}.table th, .table td {padding: 12px; border-top: 1px solid #DDD;}`;
    style = `${style}</style>`;
    const win: any = window.open('', '', 'height=700,width=700');
    if (win !== null && tab !== null) {
      win.document.write(style);
      win.document.write(tab.outerHTML);
      win.print();
      win.close();
    }
  }
}
